import React from "react";
import { currentManagedOrg, currentlyActingOnBehalf } from "../../Helpers/SuppressionOrg";

/**
 * Task 9 / A1 — says whose suppressions are on screen, when they are not your own.
 *
 * WHY THIS EXISTS. The defect this feature shipped with was silent: a reseller or master
 * administrator managing a customer saw their OWN organisation's known errors and jobs, with no
 * error and nothing on screen naming an organisation. The client read an empty list as data. The
 * scoping is fixed server-side, but nothing on the page would have revealed the fault, and nothing
 * would reveal a future one either. This is the cheapest guard against a repeat.
 *
 * Renders NOTHING for a plain organisation administrator. They have exactly one organisation, so a
 * permanent banner would be noise — and noise is what stops the banner being noticed in the case
 * that matters.
 *
 * The comparison is client-side and display-only; see SuppressionOrg.decodeLoginOrgId. If the
 * login organisation cannot be determined the banner simply does not appear, which is why its
 * ABSENCE is a soft signal too: an administrator who expected a customer's name and sees none has
 * been told something.
 */
export default function ActingOnBehalfBanner() {
    if (!currentlyActingOnBehalf()) return null;

    const { orgId, orgName } = currentManagedOrg();

    return (
        <div className="alert alert-info py-2 mb-3" role="status">
            Managing suppressions for{" "}
            {/* The id is the fallback rather than nothing: a link that carried orgId but not
                orgName must still name the organisation it is acting on. */}
            <strong>{orgName || orgId}</strong>
        </div>
    );
}
